import { types } from 'mobx-state-tree'

export const AdminSponsorModel = types
  .model('AdminSponsorModel', {
    id: types.maybeNull(types.number),
    donatedAllTime: types.maybeNull(types.number),
    logo: types.maybeNull(types.string),
    donatedLastMonth: types.maybeNull(types.number),
    name: types.maybeNull(types.string),
    fullName: types.maybeNull(types.string),
    donatedLastYear: types.maybeNull(types.number),
    sponsorLimit: types.maybeNull(types.number),
    website: types.maybeNull(types.string),
  })
  .preProcessSnapshot((snapshot) => ({
    ...snapshot,
  }))
